export default __webpack_public_path__ + "static/media/angular_material.2a52c046.png";